export default {
      id: "oc-alert-event-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-alert-event",
      toString: function () {
        return this.url;
      }
    }